<app-menu></app-menu>
<div class="container">
    <div class="header">
        <h1>Minhas Compras</h1>
    </div>

    <div *ngIf="isLoading" class="loading-spinner">
    </div>

    <div *ngIf="!isLoading && shoppingResponse.listShoppingItem.length === 0">
        <app-empty-list title="Nenhuma compra encontrada"
            subTitle="Você ainda não fez nenhuma compra em nossa loja."></app-empty-list>
    </div>

    <div *ngIf="!isLoading && shoppingResponse.listShoppingItem.length > 0" class="shopping-list">
        <div *ngFor="let item of shoppingResponse.listShoppingItem" class="shopping-item">

            @if(item.coverImageUrl){
            <img [src]="item.coverImageUrl" [alt]="'Capa do livro ' + item.title" class="book-cover">
            }
            @else{
            <img [src]="item.coverImageError" [alt]="'Capa do livro ' + item.title" class="book-cover"
                onerror="this.onerror=null;this.src='https://placehold.co/400x600/e0e0e0/333?text=Capa+Indisponível';">
            }
            <div class="book-details">
                <h2>{{ item.title }}</h2>
                <p class="author">{{ item.author }}</p>
                <p class="purchase-date-list" *ngIf="item.purchaseDate">
                    Comprado em {{ item.purchaseDate | date:'dd/MM/yyyy \'às\' HH:mm' }}
                </p>

                <div class="actions">
                    <button *ngIf="item.hasEbook" (click)="openPdf(item.ebookFileUrl)">Ler e-book agora</button>
                    <button *ngIf="item.hasVideoContent" (click)="viewVideo(item.idKit)">Ver as video aulas</button>
                    <button (click)="viewDetails(item.idKitPaymentItem)">Ver minha compra</button>
                </div>
                @if(item.isReviewedByUser == false){
                <div class="book-rating">
                    <a (click)="rateNow(item.idBook, item.idKitPaymentItem)">O que você acho deste livro? Avalie e ajude
                        outras pessoas a fazerem a
                        melhor
                        escolha</a>
                </div>
                }
                @else{
                <div class="book-rating">
                    @for (filled of stars(item.averageRating); track $index) {
                    <span class="star" [class.filled]="filled">&#9733;</span>
                    }
                </div>
                }

            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>